import { render } from "./agent.vue?vue&type=template&id=3a35d0f2&scoped=true"
import script from "./agent.vue?vue&type=script&lang=js"
export * from "./agent.vue?vue&type=script&lang=js"

import "./agent.vue?vue&type=style&index=0&id=3a35d0f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a35d0f2"

export default script